import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  scoreList: {
    marginTop: 30,
    flexDirection: "row",
    alignSelf: "center",
  },
  rangePadding: {
    paddingTop: "2vw",
  },
  rangeLine: {
    borderTopWidth: 1,
    borderTopColor: "$option_card_outline",
  },
  rangeStart: {
    borderLeftWidth: 1,
    borderLeftColor: "$option_card_outline",
    marginLeft: "3vw",
    width: "4vw",
  },
  rangeEnd: {
    borderRightWidth: 1,
    borderRightColor: "$option_card_outline",
    marginLeft: "-0.4vw",
    width: "4vw",
  },
  descriptionContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  commonLine: {
    width: "7vw",
    height: "4.1vw",
  },
  emojiOffset: {
    marginLeft: "-2.75vw",
  },
});
